<div class="container" [ngClass]="{'heightError': !data?.length}">
	<div class="title-create-container">
		<h4>{{'general.media_library' | translateWithKeys}}</h4>
		<div>
			<mat-icon class="close-icon" (click)="close()">close</mat-icon>
		</div>
	</div>
	@if(showSpinner) {
		<div class="spinner-container">
			<mat-spinner></mat-spinner>
		</div>
	}@else {
		<div class="search-filter-container">
			<div class="search-filter space-between">
				<div class="search-bar">
					<app-search-bar (searchString)="handleFilteredItems($event)" placeholder="general.search_by_file_name"></app-search-bar>
				</div>
				<div class="row-upload">
					<app-sort-by [selectedSortBy]="sortingValue"
						(sortByOption)="handleSortOptionSelected($event)" [sortByOptions]="sortByOptions"></app-sort-by>
					<button mat-flat-button *hasPermission="PermissionsEnum.CREATE_VIDEO" class="view-btn bg-primary-darker text-accent-lighter upload-btn" (click)="uploadVideo()"><mat-icon
							class="icon" svgIcon="upload_outlined"></mat-icon><span>{{'general.upload' |
							translateWithKeys}}</span></button>
				</div>

			</div>
			<div>
			</div>
		</div>
		@if(data.length){
		<app-table #tableComponent [dataSource]="data" [table]="table" (selectedItems)="sendVideoData($event)"
			(selectedItemToDelete)="deleteItem($event)"></app-table>
		}@else {
		<div class="errorImage">
			@if(!showSpinner && !this.data.length){
			<app-empty-state image="assets/images/courses-media-library.png"
				title="course-creation.no_videos_course_language"
				text="course-creation.can_upload_some_media_content"></app-empty-state>
			}@else{
			<app-empty-state></app-empty-state>
			}
		</div>
		}
	}
	<app-paging [options]="queryOptions" (itemsChange)="filteredData($event)"></app-paging>

</div>

<ng-template #videoThumbnail let-element="element">
	<div class="thumbnail-and-name" [ngClass]="{'disabled': !element?.uploaded || !element?.video}">
		<div class="img-container">
			@if (element?.fileType === MediaFileType.PDF) {
				<img class="img-table inherit-fit" [src]="pdfThumbnail" alt="img">
			} @else {
				<img class="img-table" src="{{element.thumbnail}}" alt="img">
			}
		</div>
		<span>{{element.fileName | truncate:45}}</span>

	</div>
</ng-template>

<ng-template #videoDuration let-element="element">
	<div class="title-container" [ngClass]="{'disabled': !element?.uploaded || !element?.video}">
		<span>{{element.duration | timeFormat }}</span>
	</div>
</ng-template>
<ng-template #videoCreated let-element="element">
	<div class="title-container" [ngClass]="{'disabled': !element?.uploaded || !element?.video}">
		<span>{{element.__createdAt.seconds*1000 | appDate }}</span>
	</div>
</ng-template>

<ng-template #videoLanguage let-element="element">
	<div class="title-container" [ngClass]="{'disabled': !element?.uploaded || !element?.video}">
		<span>{{element.language.name | translateWithKeys}}</span>
	</div>
</ng-template>

<ng-template #mediaLibraryActionColumn let-element="element" let-index="index">
	@if (videoUploadProgressQueue?.[element?.id] && ((videoUploadProgressQueue[element?.id] | async) !== null)) {
		<div class="flex row gap space-between center">
			<mat-progress-bar [value]="videoUploadProgressQueue?.[element?.id] | async" class="progress-bar-width"></mat-progress-bar>
			<span class="percentage-progress-bar">{{ videoUploadProgressQueue?.[element?.id] | async }} %</span>
		</div>
	} @else {
		<div class="flex row end center">
			@if (!element?.uploaded) {
				<div class="flex row center gap-5 relative">
					<mat-icon svgIcon="error_rounded" class="icon-position" color="warn"></mat-icon>
					<p class="m-0">{{ 'general.upload_failed' | translateWithKeys }}</p>
				</div>
			}
		</div>
	}
</ng-template>
